module.exports = __webpack_public_path__ + "c9ccd27c8be63dffd1eef0bfe69e17ae.svg";